/** 
  Author: Lokesh Arora - lokesh.arora@enabledata.com
  Purpose: Import api models
  Date: April 2020
**/

import { action, thunk } from 'easy-peasy';
import * as importService from '../../services/import';

const importModel = {
  importTypes: [],
  job: {},
  setJob: action((state, payload) => {
    state.job = payload;
  }),

  setImportTypes: action((state, payload) => {
    state.importTypes = payload;
  }),

  getImportTypes: thunk(async (actions, payload) => {
    await importService
      .getImportTypes(payload)
      .then(function (response) {
        actions.setImportTypes(response.data.data);
      })
      .catch(function (error) {
        console.log('Error', error);
        actions.setImportTypes([]);
      });
  }),

  getPreSignedUrl: thunk(async (actions, payload) => {
    return await importService.getPreSignedUrl(payload);
  }),

  uploadToS3: thunk(async (actions, payload) => {
    return await importService.uploadToS3(payload);
  }),

  jobList: [],
  setJobList: action((state, payload) => {
    state.jobList = payload;
  }),
  jobListLoader: false,
  setJobListLoader: action((state, payload) => {
    state.jobListLoader = payload;
  }),
  getJobList: thunk(async (actions, payload) => {
    await importService.getJobList(payload)
      .then(function (response) {
        actions.setJobListLoader(false);
        actions.setJobList(response.data.data);
      })
      .catch(function (error) {
        actions.setJobListLoader(false);
        actions.setJobList([]);
      });
  }),

  upload: thunk(async (actions, payload) => {
    return await importService.upload(payload);
  }),
  pa_upload: thunk(async (actions, payload) => {
    return await importService.pa_upload(payload);
  }),

  getJob: thunk(async (actions, payload) => {
    return await importService.getJob(payload);
  }),

  importJob: thunk(async (actions, payload) => {
    return await importService.importJob(payload);
  }),

  previewAgain: thunk(async (actions, payload) => {
    return await importService.previewAgain(payload);
  }),
};

export default importModel;
